import styled from "styled-components";

export const NotesContainer = styled.div`
  width: 100%;
`;

export const TabsContainer = styled.div`
  display: flex;
  padding: ${(p) => p.theme.spacing[4]};
  border-bottom: 1px solid ${({ theme }) => theme.isDarkMode ? '#1e293b' : theme.colors.neutral[200]};
  background: ${(p) => p.theme.isDarkMode ? '#0f172a' : p.theme.colors.surface.paper};
`;

export const Tab = styled.button`
  padding: ${(p) => p.theme.spacing[2]} ${(p) => p.theme.spacing[4]};
  background: ${(p) =>
    p.$active ? p.theme.colors.accent.main : "transparent"};
  color: ${(p) =>
    p.$active ? p.theme.colors.neutral[50] : p.theme.colors.neutral[400]};
  border: none;
  border-radius: ${(p) => p.theme.radii.md};
  font-weight: ${(p) => p.theme.typography.fontWeights.medium};
  cursor: pointer;
  transition: all ${(p) => p.theme.animations.durations.fast}
    ${(p) => p.theme.animations.timings.ease};

  &:hover {
    background: ${(p) =>
      p.$active ? p.theme.colors.accent.hover : p.theme.colors.surface.raised};
  }

  & + & {
    margin-left: ${(p) => p.theme.spacing[2]};
  }
`;

export const ContentSection = styled.div`
  padding: ${(p) => p.theme.spacing[4]};
`;

export const SectionCard = styled.div`
  background: ${(p) => p.theme.isDarkMode ? '#0f172a' : p.theme.colors.surface.paper};
  border-radius: ${(p) => p.theme.radii.lg};
  padding: ${(p) => p.theme.spacing[4]};
  margin-bottom: ${(p) => p.theme.spacing[4]};
  border: 1px solid ${({ theme }) => theme.isDarkMode ? '#1e293b' : theme.colors.neutral[200]};
`;

export const SectionTitle = styled.h2`
  font-size: ${(p) => p.theme.typography.fontSizes.lg};
  font-weight: ${(p) => p.theme.typography.fontWeights.semibold};
  color: ${(p) => p.theme.colors.neutral[900]};
  margin-bottom: ${(p) => p.theme.spacing[4]};
`;

export const SummaryTextArea = styled.textarea`
  width: 100%;
  min-height: 120px;
  padding: ${(p) => p.theme.spacing[3]};
  border: 1px solid ${({ theme }) => theme.isDarkMode ? theme.colors.neutral[700] : theme.colors.neutral[200]};
  border-radius: ${(p) => p.theme.radii.md};
  background: ${(p) => p.theme.colors.surface.raised};
  color: ${(p) => p.theme.colors.neutral[800]};
  font-size: ${(p) => p.theme.typography.fontSizes.base};
  resize: vertical;

  &:focus {
    outline: none;
    border-color: ${(p) => p.theme.colors.accent.main};
  }

  &::placeholder {
    color: ${(p) => p.theme.colors.neutral[500]};
  }
`;

export const ActionBar = styled.div`
  display: flex;
  gap: ${(p) => p.theme.spacing[2]};
  margin-top: ${(p) => p.theme.spacing[3]};
`;

export const ActionButton = styled.button`
  display: flex;
  align-items: center;
  gap: ${(p) => p.theme.spacing[2]};
  padding: ${(p) => p.theme.spacing[2]} ${(p) => p.theme.spacing[3]};
  border-radius: ${(p) => p.theme.radii.md};
  font-size: ${(p) => p.theme.typography.fontSizes.sm};
  font-weight: ${(p) => p.theme.typography.fontWeights.medium};
  background: ${(p) => p.theme.isDarkMode ? p.theme.colors.surface.raised : p.theme.colors.accent.surface};
  color: ${(p) => p.theme.isDarkMode ? '#fff' : p.theme.colors.accent.main};
  border: none;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: ${(p) => p.theme.colors.accent.hover};
    color: #fff;
  }
`;

export const UpdatesList = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${(p) => p.theme.spacing[3]};
`;

export const UpdateItem = styled.div`
  display: flex;
  gap: ${(p) => p.theme.spacing[3]};
  align-items: flex-start;
`;

export const UpdateIcon = styled.div`
  font-size: ${(p) => p.theme.typography.fontSizes.xl};
  min-width: 24px;
  text-align: center;
`;

export const UpdateContent = styled.div`
  flex: 1;
`;

export const UpdateTitle = styled.div`
  font-weight: ${(p) => p.theme.typography.fontWeights.semibold};
  color: ${(p) => p.theme.colors.neutral[900]};
  margin-bottom: ${(p) => p.theme.spacing[1]};
`;

export const UpdateText = styled.textarea`
  width: 100%;
  min-height: 60px;
  padding: ${(p) => p.theme.spacing[2]};
  border: 1px solid ${({ theme }) => theme.isDarkMode ? theme.colors.neutral[700] : theme.colors.neutral[200]};
  border-radius: ${(p) => p.theme.radii.md};
  background: ${(p) => p.theme.colors.surface.raised};
  color: ${(p) => p.theme.colors.neutral[800]};
  font-size: ${(p) => p.theme.typography.fontSizes.sm};
  resize: vertical;

  &:focus {
    outline: none;
    border-color: ${(p) => p.theme.colors.accent.main};
  }
`;

export const TaskList = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${(p) => p.theme.spacing[2]};
  margin-bottom: ${(p) => p.theme.spacing[4]};
`;

export const TaskItem = styled.div`
  display: flex;
  align-items: center;
  gap: ${(p) => p.theme.spacing[2]};
`;

export const Checkbox = styled.input.attrs({ type: "checkbox" })`
  width: 18px;
  height: 18px;
  cursor: pointer;
`;

export const TaskInput = styled.input`
  flex: 1;
  padding: ${(p) => p.theme.spacing[2]};
  border: 1px solid ${({ theme }) => theme.isDarkMode ? theme.colors.neutral[700] : theme.colors.neutral[200]};
  border-radius: ${(p) => p.theme.radii.md};
  background: ${(p) => p.theme.colors.surface.raised};
  color: ${(p) => p.theme.colors.neutral[800]};
  font-size: ${(p) => p.theme.typography.fontSizes.sm};

  &:focus {
    outline: none;
    border-color: ${(p) => p.theme.colors.accent.main};
  }

  &::placeholder {
    color: ${(p) => p.theme.colors.neutral[500]};
  }
`;

export const AddButton = styled(ActionButton)`
  min-width: 80px;
  background: ${(p) => p.theme.isDarkMode ? p.theme.colors.surface.raised : p.theme.colors.accent.surface};
  color: ${(p) => p.theme.isDarkMode ? '#fff' : p.theme.colors.accent.main};
`;

export const SaveButton = styled(ActionButton)`
  background: ${(p) => p.theme.colors.accent.main};
  color: #fff;

  &:hover {
    background: ${(p) => p.theme.colors.accent.hover};
  }
`;

export const Footer = styled.div`
  padding: ${(p) => p.theme.spacing[4]};
  background: ${(p) => p.theme.isDarkMode ? '#0f172a' : p.theme.colors.surface.paper};
  border-top: 1px solid ${({ theme }) => theme.isDarkMode ? '#1e293b' : theme.colors.neutral[200]};
`;

export const StyledDrawer = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  width: 360px;
  background: ${(p) => p.theme.isDarkMode ? '#0f172a' : p.theme.colors.surface.default};
  box-shadow: ${({ theme }) => theme.isDarkMode ? "none" : theme.shadows.md};
  display: flex;
  flex-direction: column;
  z-index: 1200;
`;

export const DrawerHeader = styled.div`
  padding: ${(p) => p.theme.spacing?.[4] || "16px"};
  border-bottom: 1px solid ${({ theme }) => theme.isDarkMode ? '#1e293b' : theme.colors.neutral[200]};
  background: ${(p) => p.theme.isDarkMode ? '#0f172a' : p.theme.colors.surface.paper};
`;

export const HeaderTitle = styled.h2`
  color: ${(p) => p.theme.colors.neutral?.[50] || "#F8FAFC"};
  font-weight: ${(p) => p.theme.typography?.fontWeights.semibold || 600};
  font-size: ${(p) => p.theme.typography?.fontSizes.xl || "1.25rem"};
  margin: 0;
`;

export const HeaderSubtitle = styled.p`
  color: ${(p) => p.theme.colors.neutral?.[400] || "#94A3B8"};
  font-size: ${(p) => p.theme.typography?.fontSizes.sm || "0.875rem"};
  margin: ${(p) => p.theme.spacing?.[2] || "8px"} 0 0;
`;

export const ScrollContent = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: ${(p) => p.theme.spacing?.[4] || "1rem"};

  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background: ${(p) => p.theme.colors.surface?.default || "#0F172A"};
  }

  &::-webkit-scrollbar-thumb {
    background: ${(p) => p.theme.colors.neutral?.[700] || "#334155"};
    border-radius: ${(p) => p.theme.radii?.full || "9999px"};
  }

  &::-webkit-scrollbar-thumb:hover {
    background: ${(p) => p.theme.colors.neutral?.[600] || "#475569"};
  }
`;
